import { FC } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { reviewService } from '@/services/review.service';
import FormBtn from '../form/form-btn/FormBtn';
import { REG_EXP_WEB_LINK } from '@/helpers/variables';
import { checkSqlWords } from '@/helpers/helpers';
import styles from './FormReview.module.scss';

interface IFormReview {
  bookId: number;
  bookAlias: string;
  noMargin?: boolean;
  isBlogPage?: boolean;
}

const FormReview: FC<IFormReview> = ({ bookId, bookAlias, noMargin, isBlogPage }) => {
  const VALIDATION_NOT_PASS_TXT = 'Текст отзыва не прошел валидацию. Наберите еще раз.';
  const VALIDATION_PASS_TXT = 'Спасибо! Ваш отзыв был отправлен на модерацию.';

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
      email: '',
      message: '',
      book_id: bookId,
      book_alias: bookAlias,
      status: 'active',
    },
  });

  const [isModerateNoteVisible, setIsModerateNoteVisible] = useState(false);
  const [moderationText, setModerationText] = useState('');

  const showModerationMessage = (text: string) => {
    setModerationText(text);
    setIsModerateNoteVisible(true);
    setTimeout(() => {
      setIsModerateNoteVisible(false);
    }, 2500);
  };

  return (
    <form
      className={noMargin ? `${styles.bookReviewForm} ${styles.bookReviewForm_noMargin}` : `${styles.bookReviewForm}`}
      onSubmit={handleSubmit((data) => {
        if (REG_EXP_WEB_LINK.test(data.message) || checkSqlWords(data.message)) {
          showModerationMessage(VALIDATION_NOT_PASS_TXT);
          return null;
        }

        if (isBlogPage) {
          reviewService.postBlogReview({ name: data.name, email: data.email, message: data.message, post_id: data.book_id });
        } else {
          reviewService.postReview(data);
        }

        showModerationMessage(VALIDATION_PASS_TXT);
        reset();
      })}
    >
      <div className={styles.bookReviewForm__row}>
        <div className={styles.item}>
          <input {...register('name', { required: true, minLength: 3 })} defaultValue="Ваше имя" placeholder="Имя" className={errors.name ? `${styles.input} ${styles.errorBg}` : `${styles.input}`} />
          {errors.name && <span className={styles.errorMessage}>Никнейм должен быть больше 3 символов</span>}
        </div>

        <div className={styles.item}>
          <input {...register('email')} placeholder="Email" className={`${styles.input} ${styles.recense_email}`} />
        </div>
      </div>

      <div className={styles.item}>
        <textarea
          {...register('message', { required: true, minLength: 8 })}
          placeholder={isBlogPage ? 'Что вы думаете о блоге?' : 'Что вы думаете о книге?'}
          className={errors.message ? `${styles.textarea} ${styles.errorBg}` : `${styles.textarea}`}
        />
        {errors.message && <span className={styles.errorMessage}>Текст должен быть больше 8 символов</span>}
      </div>

      <div>
        <div className={styles.sendButton}>
          <FormBtn type="submit" value="Отправить" />
        </div>
      </div>
      {isModerateNoteVisible && <div className={moderationText.includes('не прошел') ? `${styles.bookReviewForm__moderationTxt} ${styles.bookReviewForm__moderationTxt_red}` : `${styles.bookReviewForm__moderationTxt}`}>{moderationText}</div>}
    </form>
  );
};

export default FormReview;
